import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { money } from "@/data/products";
import { useCart } from "@/context/CartContext";

const TrioArt = () => (
  <div className="flex items-end justify-center -space-x-6 h-full">
    {["watermelon", "pineapple", "apple"].map((id, i) => (
      <img key={id} src={`/img/bottle_${id}.webp`} alt={`${id} juice bottle`} className={`h-[88%] object-contain drop-shadow-2xl ${i === 1 ? "z-10 -translate-y-3" : ""}`} />
    ))}
  </div>
);

export const ProductCard = ({ p, big = false }) => {
  const { add, setOpen } = useCart();

  const onAdd = () => {
    add(p.id);
    toast.success(`${p.name} added to cart`);
    setOpen(true);
  };

  return (
    <motion.article
      data-testid={`product-card-${p.id}`}
      whileHover={{ y: -6 }}
      transition={{ type: "spring", stiffness: 200, damping: 20 }}
      className="relative h-full rounded-[2rem] overflow-hidden flex flex-col p-6 md:p-8"
      style={{ background: p.bg, color: p.text }}
    >
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.25em] opacity-80">{p.fruit}</p>
          <h3 className={`font-display font-extrabold tracking-tight mt-2 ${big ? "text-4xl md:text-6xl" : "text-3xl md:text-4xl"}`}>{p.name}</h3>
        </div>
        <span data-testid={`product-price-${p.id}`} className="font-display text-2xl font-bold">{money(p.price)}</span>
      </div>
      <div className={`relative flex-1 my-6 ${big ? "min-h-[320px] md:min-h-[420px]" : "min-h-[240px]"}`}>
        <div className="absolute inset-0" style={{ background: "radial-gradient(closest-side, rgba(255,255,255,0.38), rgba(255,255,255,0) 75%)" }} />
        {p.img ? (
          <img src={p.img} alt={`${p.fruit} juice bottle`} className="relative h-full max-h-[460px] mx-auto object-contain drop-shadow-2xl transition-transform duration-700 hover:scale-105 hover:-rotate-3" />
        ) : (
          <div className="absolute inset-0"><TrioArt /></div>
        )}
      </div>
      <div className="flex flex-wrap gap-2 mt-4">
        {p.stats.map((s) => (
          <span key={s} className="text-xs font-semibold rounded-full px-3 py-1" style={{ borderColor: `${p.text}55`, border: `1px solid ${p.text}55` }}>{s}</span>
        ))}
      </div>
      <motion.button
        whileTap={{ scale: 0.94 }}
        data-testid={`add-to-cart-button-${p.id}`}
        onClick={onAdd}
        className="mt-6 self-start inline-flex items-center gap-2 h-11 px-5 rounded-full font-bold text-sm"
        style={{ background: p.text, color: p.bg }}
      >
        <Plus className="w-4 h-4" /> Add to cart
      </motion.button>
    </motion.article>
  );
};
